<lh-header-bar [content]="data.title" (onClose)="gotoHome('POPUP')"></lh-header-bar>
@for (phone of data.message; track $index) {
    <div id="phone-numbers">
        <div class="card card--clickable card-bg bonus-card card-active-shadow option-card">
            <div class="card-body">
                <div class="theme-contact option-icon portrait"></div>
                <div class="bonus-card-heading-2 align-left">
                    <span class="cursorPointer" [innerHtml]="phone.title" (click)="callTo(phone.title)"></span>
                </div>
                <div class="text-muted-secondary bonus-card-heading-1-small align-left" [innerHtml]="phone.text"></div>
            </div>
        </div>
    </div>
}
